import { Injectable } from '@angular/core';

import { SessionStoreService } from '@frontend/vanilla/core';

import { SelectionInfo } from '../../event-details-common/event-details-common.models';
import { NavState } from '../navigation-state/navigation-state';

export interface SessionData {
    selection?: SelectionInfo;
    expandedSports: number[];
    collapsedLeagues: number[];
    sportsWithCollapsedMarkets: number[];
}

@Injectable({ providedIn: 'root' })
export class LiveEventsNavigationStateService {
    private readonly sessionKey: string = 'live-navigation-state';
    state: NavState;

    constructor(private sessionStore: SessionStoreService) {
        this.state = this.loadState();
    }

    private loadState(): NavState {
        const rawState: SessionData = this.sessionStore.get<SessionData>(this.sessionKey) || {
            expandedSports: [],
            collapsedLeagues: [],
            sportsWithCollapsedMarkets: [],
        };

        return new NavState(rawState.selection, rawState.expandedSports, rawState.collapsedLeagues, rawState.sportsWithCollapsedMarkets);
    }

    storeState(): void {
        this.sessionStore.set(this.sessionKey, {
            selection: this.state.selection,
            expandedSports: Array.from(this.state.expandedSports),
            collapsedLeagues: Array.from(this.state.collapsedLeagues),
            sportsWithCollapsedMarkets: Array.from(this.state.sportsWithCollapsedMarkets),
        });
    }

    storeSelection(selection: SelectionInfo): void {
        this.state.selection = selection;
        this.storeState();
    }

    toggleSport(sportId: number): void {
        this.state.toggleSport(sportId);
        this.storeState();
    }

    toggleLeague(leagueId: number): void {
        this.state.toggleLeague(leagueId);
        this.storeState();
    }

    toggleMarkets(sportId: number): void {
        this.state.toggleMarkets(sportId);
        this.storeState();
    }
}
